/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bestStreak: NonNullable<unknown>, elapsed: NonNullable<unknown> }} Game_Meta_DailyInputs */

const bn_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`সেরা স্ট্রীক ${i?.bestStreak} • ${i?.elapsed}`)
};

const de_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beste Serie ${i?.bestStreak} • ${i?.elapsed}`)
};

const el_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Καλύτερο σερί ${i?.bestStreak} • ${i?.elapsed}`)
};

const en_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Best streak ${i?.bestStreak} • ${i?.elapsed}`)
};

const es_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mejor racha ${i?.bestStreak} • ${i?.elapsed}`)
};

const fr_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meilleure série ${i?.bestStreak} • ${i?.elapsed}`)
};

const hi_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सर्वोत्तम स्ट्रीक ${i?.bestStreak} • ${i?.elapsed}`)
};

const hu_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Legjobb sorozat ${i?.bestStreak} • ${i?.elapsed}`)
};

const id_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rekor terbaik ${i?.bestStreak} • ${i?.elapsed}`)
};

const it_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miglior serie ${i?.bestStreak} • ${i?.elapsed}`)
};

const ja_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最高の連続記録 ${i?.bestStreak} • ${i?.elapsed}`)
};

const ko_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`최고 연속 기록 ${i?.bestStreak} • ${i?.elapsed}`)
};

const nl_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beste reeks ${i?.bestStreak} • ${i?.elapsed}`)
};

const pl_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Najlepsza passa ${i?.bestStreak} • ${i?.elapsed}`)
};

const pt_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Melhor sequência ${i?.bestStreak} • ${i?.elapsed}`)
};

const ru_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Лучшая серия ${i?.bestStreak} • ${i?.elapsed}`)
};

const sv_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bästa rad ${i?.bestStreak} • ${i?.elapsed}`)
};

const tr_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En iyi seri ${i?.bestStreak} • ${i?.elapsed}`)
};

const uk_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Найкраща серія ${i?.bestStreak} • ${i?.elapsed}`)
};

const vi_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kỷ lục tốt nhất ${i?.bestStreak} • ${i?.elapsed}`)
};

const zh_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最佳纪录 ${i?.bestStreak} • ${i?.elapsed}`)
};

const zh_hant_game_meta_daily = /** @type {(inputs: Game_Meta_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最佳紀錄 ${i?.bestStreak} • ${i?.elapsed}`)
};

/**
* | output |
* | --- |
* | "Best streak {bestStreak} • {elapsed}" |
*
* @param {Game_Meta_DailyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_meta_daily = /** @type {((inputs: Game_Meta_DailyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Meta_DailyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_meta_daily(inputs)
	if (locale === "de") return de_game_meta_daily(inputs)
	if (locale === "el") return el_game_meta_daily(inputs)
	if (locale === "en") return en_game_meta_daily(inputs)
	if (locale === "es") return es_game_meta_daily(inputs)
	if (locale === "fr") return fr_game_meta_daily(inputs)
	if (locale === "hi") return hi_game_meta_daily(inputs)
	if (locale === "hu") return hu_game_meta_daily(inputs)
	if (locale === "id") return id_game_meta_daily(inputs)
	if (locale === "it") return it_game_meta_daily(inputs)
	if (locale === "ja") return ja_game_meta_daily(inputs)
	if (locale === "ko") return ko_game_meta_daily(inputs)
	if (locale === "nl") return nl_game_meta_daily(inputs)
	if (locale === "pl") return pl_game_meta_daily(inputs)
	if (locale === "pt") return pt_game_meta_daily(inputs)
	if (locale === "ru") return ru_game_meta_daily(inputs)
	if (locale === "sv") return sv_game_meta_daily(inputs)
	if (locale === "tr") return tr_game_meta_daily(inputs)
	if (locale === "uk") return uk_game_meta_daily(inputs)
	if (locale === "vi") return vi_game_meta_daily(inputs)
	if (locale === "zh") return zh_game_meta_daily(inputs)
	return zh_hant_game_meta_daily(inputs)
});